import { useProduct } from '../ProductProvider';
import { useGlobal } from '@/utils/useGlobal';
import { pageParams } from '../config/page';
import getLocal from '@/app/utils/i18n';

export default function getProductMsg() {
    const { state, dispatch } = useProduct();
    const { locale } = getLocal();
    const { generalKeys, generalKeys_eu, generalKeys_ph, generalKeys_nl } = pageParams;

    const curGeneralKeys = locale === 'nl' ? generalKeys_nl : locale === 'ph' ? generalKeys_ph : locale === 'jp' ? generalKeys : generalKeys_eu;

    if (state.productMsg && state.productMsg.length === curGeneralKeys.length) return;
    const { gloproductlist } = useGlobal();

    let productMsgMap: any = {};
    curGeneralKeys.map((generalKey: string) => {
        const target = gloproductlist?.find((item: any) => item.generalKey === generalKey);

        if (target) {
            productMsgMap[generalKey] = target || {};
        }
    });
    dispatch({
        type: 'changeProductMsg',
        payload: productMsgMap,
    });
}
